// import React, { useState, useEffect } from "react";
// import { Link } from 'react-router-dom';
// import styled from "styled-components";
// import { Search } from "lucide-react";
// import { isMobile, Event } from "../../../../Helper";
// import Login from "../../Auth/Login";
// import Register from "../../Auth/Register";
// import { GrSearchAdvanced } from "react-icons/gr";
// import { Menu, X } from 'lucide-react';
// import { RiMessageFill } from "react-icons/ri";
// import { TbWorld } from "react-icons/tb";

// const ToggleButton = styled.button`

// background: none;
// border: none;
// color: white;
// font-size: 24px;
// cursor: pointer;
// z-index: 1001;

// `;

// const HeaderContainer = styled.header`
//   background-color: #292d2e !important;
//   height: 80px;
//   display: flex;
//   border:1px solid red;
//   width: 90% !important;
//   align-items: center;
//   padding: 0 20px;
//     z-index:1000;
//   justify-content: space-between;
//   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
// `;

// const SearchBarContainer = styled.div`
//   display: flex;
//   // align-items: center;
//   background-color: #3a4142;
//   border-radius:5px;
//   padding:7px;
//   // width: 10%;

//   max-width: 600px;
//   transition: outline 0.2s ease-in-out;
//   border: ${props => props.isFocused ? '2px solid rgb(255, 168, 0)' : '2px solid transparent'};
// `;

// const SearchInput = styled.input`
//   background-color: transparent;
//   border: none;
//   color: #ffffff;
//   font-size: 14px;
//   width: 100%;
//   margin-left: 8px;
//   outline: none;

//   &::placeholder {
//     color: #a0a0a0;
//   }
// `;

// const LogoContainer = styled.div`
//   margin-right: 10px;
// `;

// const FullLogo = styled.img`
//   height: auto;
//   width: 150px;
// `;

// const ShortLogo = styled.div`
//   font-size: 20px;
//   font-weight: bold;
//   font-style: italic;
// `;
// const RightWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   width:100%;
//   gap: 10px;
//   padding-right: 350px;

//   @media (max-width: 1200px) {
//     padding-right: 150px;
//   }

//   @media (max-width: 992px) {
//     padding-right: 100px;
//   }

//   @media (max-width: 768px) {
//     padding-right: 50px;
//   }

//   @media (max-width: 576px) {
//     padding-right: 20px;
//   }
// `;

// const Header = ({ isCollapsedMobile, setIsCollapsedMobile }) => {
//   const [show, setShow] = useState(true);
//   const [showLogo, setShowLogo] = useState(window.innerWidth > 768);
//   useEffect(() => {
//     const handleResize = () => {
//       setShowLogo(window.innerWidth > 768);
//     };

//     window.addEventListener('resize', handleResize);
//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   const collapse = () => {
//     setShow(!show);
//     Event.emit("toggle_sidebar", show);
//   };

//   const renderContent = () => (
//     <HeaderContainer>

//       <div>
//         {
//           !showLogo && (
//             <ToggleButton onClick={() => setIsCollapsedMobile(!isCollapsedMobile)}>
//               {isCollapsedMobile ? (
//                 <X size={24} style={{ position: 'absolute', left: '191px' }} />
//               ) : (
//                 <Menu size={24} />
//               )}
//             </ToggleButton>
//           )
//         }
//         <LogoContainer>
//           <Link to="/">
//             {showLogo ? (
//               <FullLogo src="/assets/bcimages/assamgames.png" alt="Logo" />
//             ) : (
//               <ShortLogo>
//                 <span style={{ color: '#CD7F28' }}>F</span>
//                 <span style={{ color: '#00BF63' }}>P</span>
//               </ShortLogo>
//             )}
//           </Link>
//         </LogoContainer>
//       </div>

//       <div style={{ display:'flex', gap: '15px' ,border:"1px solid red"}}>
//         <SearchBarContainer >
//           <GrSearchAdvanced size={25} />
//           {/* <Search size={40} color="#a0a0a0" /> */}
//           {/* <SearchInput placeholder="Search..." /> */}
//         </SearchBarContainer>

//         <RightWrapper style={{justifyContent:"right",textAlign:"right"}}>
//           <Login />
//           <Register />
//           {/* <div className="message-btn"> */}
//           <SearchBarContainer style={{ padding: "8px", width: "100%" }} >
//             <RiMessageFill size={20} />
//           </SearchBarContainer>
//           {/* </div> */}
//           <div style={{padding:"7px",borderRadius:"5px",backgroundColor:"#3a4142"}}>
//           <div style={{position:"relative",display:"flex",borderRadius:"5px",width:"auto"}} >
//         <div  className="country-icon" style={{borderRight:"1px solid white"}}>
//         <TbWorld size={25}/>
//         </div>
//       <div>

//         </div>
//         <div  className="country-icon ">
//           <span className="game-fonts">
//             INR
//           </span>
//         </div>
//         </div>
//         </div>
//         </RightWrapper>

//       </div>

//     </HeaderContainer>
//   );

//   return renderContent();
// };

// export default Header;

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Search } from "lucide-react";
import { isMobile, Event } from "../../../../Helper";
import Login from "../../Auth/Login";
import Register from "../../Auth/Register";
import { GrSearchAdvanced } from "react-icons/gr";
import { Menu, X } from "lucide-react";
import { RiMessageFill } from "react-icons/ri";
import { TbWorld } from "react-icons/tb";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import Chat from "../Chat/index";
import { useTranslation } from "react-i18next";
import ExploreModal from "./ExploreModal";

const handleTabClick = (e) => {
  const tabs = document.querySelectorAll(".snapbet-bottom-bar-main li a");
  tabs.forEach((tab) => tab.classList.remove("active"));
  e.currentTarget.classList.add("active");
};

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
`;

const HeaderContainer = styled.header`
  background-color: #292d2e !important;
  height: 60px;
  display: flex;
  align-items: center;
  width: 100%; // Ensures the header takes full width
  // max-width: 1400px; // Maximum width to prevent stretching on large screens
  // Center the header horizontally
  padding: 0 20px;
  z-index: 1000;
  justify-content: space-between;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    padding: 0 10px; // Reduce padding on smaller screens
  }
`;

const SearchBarContainer = styled.div`
  display: flex;
  background-color: #3a4142;
  border-radius: 5px;
  padding: 7px;
  max-width: 600px;
  width: 100%;
  transition: outline 0.2s ease-in-out;
  border: ${(props) =>
    props.isFocused ? "2px solid rgb(255, 168, 0)" : "2px solid transparent"};
`;

const SearchInput = styled.input`
  background-color: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  margin-left: 8px;
  outline: none;

  &::placeholder {
    color: #a0a0a0;
  }
`;

const LogoContainer = styled.div`
  margin-right: 10px;
`;

const FullLogo = styled.img`
  height: auto;
  width: 150px;
`;

const ShortLogo = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-style: italic;
`;

const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  // padding-right: 250px;
  width: 100%;
  justify-content: flex-end;

  // @media (max-width: 1200px) {
  //   padding-right: 240px;
  //        align-items: flex-end;
  // }

  // @media (max-width: 992px) {
  //   padding-right: 230px;

  // }

  // @media (max-width: 768px) {
  //   padding-right: 50px;
  //   align-items: flex-end;
  // }

  // @media (max-width: 576px) {
  //   padding-right: 20px;
  // }
`;

const Header = ({ isCollapsedMobile, setIsCollapsedMobile }) => {
  const [show, setShow] = useState(true);
  const [showLogo, setShowLogo] = useState(window.innerWidth > 768);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpen1, setModalOpen1] = useState(false);

  const toggleModal1 = () => {
    setModalOpen1(!isModalOpen1);
  };

  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => {
      setShowLogo(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const collapse = () => {
    setShow(!show);
    Event.emit("toggle_sidebar", show);
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const renderContent = () => (
    <div>
      <HeaderContainer>
        <div style={{ display: "flex", alignItems: "center" }}>
          {!showLogo && (
            <ToggleButton
              onClick={() => setIsCollapsedMobile(!isCollapsedMobile)}
            >
              {/* {isCollapsedMobile ? <X size={24} /> : <Menu size={24} />} */}
              <img
                style={{ width: "130px", height: "40px" }}
                src="/assets/bcimages/assamgames.png"
              />
            </ToggleButton>
          )}
          <LogoContainer>
            <Link to="/">
              {showLogo ? (
                <></>
              ) : (
                // <FullLogo src="/assets/bcimages/assamgames.png" alt="Logo" />
                <ShortLogo>
                  {/* <span style={{ color: '#CD7F28' }}>F</span>
                <span style={{ color: '#00BF63' }}>P</span> */}
                  <img
                    src="/assets/bcimages/coin-logo-bc338b33.webp"
                    className="icon-logo"
                    style={{ width: "25px" }}
                  />
                  <img
                    src="/assets/bcimages/coin-logo-bc338b33.webp"
                    className="icon-logo"
                    style={{ width: "25px" }}
                  />
                </ShortLogo>
              )}
            </Link>
          </LogoContainer>
        </div>

        <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
          {/* <SearchBarContainer
            onClick={toggleModal1}
            className="message-container"
          >
            <GrSearchAdvanced size={25} style={{ color: "#b3bec1" }} />
          </SearchBarContainer> */}

          <RightWrapper>
            <Login />
            <Register />
            {/* <SearchBarContainer
              onClick={toggleModal}
              className="message-container"
              style={{ padding: "8px", width: "auto", cursor: "pointer" }}
            >
              <RiMessageFill size={20} style={{ color: "#b3bec1" }} />
            </SearchBarContainer> */}
            <div
              className="country-container"
              style={{
                padding: "7px",
                borderRadius: "5px",
                backgroundColor: "#3a4142",
              }}
            >
              <div
                style={{
                  display: "flex",
                  borderRadius: "5px",
                  alignItems: "center",
                }}
              >
                <div
                  className="country-icon"
                  // style={{ borderRight: "1px solid #b3bec1" }}
                >
                  <TbWorld size={25} style={{ color: "#b3bec1" }} />
                </div>
              </div>
            </div>
          </RightWrapper>
        </div>
      </HeaderContainer>

      {/* Modal Components */}
      <Modal
        isOpen={isModalOpen1}
        onRequestClose={toggleModal1}
        contentLabel="Referral Terms & Conditions"
        className="explore-modal"
        overlayClassName="custom-overlay"
      >
        <h2>Explore</h2>
        <button onClick={toggleModal1} className="close-modal-button">
          <RxCross2 />
        </button>
        <div
          style={{
            overflowY: "scroll",
            height: "85vh",
            width: "100%",
            zIndex: "99999",
          }}
        >
          <ExploreModal />
        </div>
      </Modal>

      {/* Modal Components */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="Chat"
        className="custom-modal"
        overlayClassName="custom-overlay"
        style={{
          content: {
            padding: 0,
            backgroundColor: "#323738",
            width: "100%",
            margin: "auto",
            borderRadius: "10px",
          },
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
        }}
      >
        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
          <h2 style={{ color: "white", margin: 0 }}>Chat</h2>
          <RxCross2 size={20} style={{ color: "white", cursor: "pointer" }} onClick={toggleModal} />
        </div> */}
        <div style={{ height: "calc(100% - 50px)" }}>
          <Chat t={t} toggleModal={toggleModal} />
        </div>
      </Modal>

      <div className="snapbet-bottom-bar">
        <ul className="snapbet-bottom-bar-main">
          <li onClick={() => setIsCollapsedMobile(!isCollapsedMobile)}>
            <a className="active" onClick={handleTabClick}>
              <img
                className="icon-home"
                src="\assets\bcimages\sidebar\bcmenu.svg"
              />
              <p>Menu</p>
            </a>
          </li>

          <Link to="/affiliate">
            <li>
              <a onClick={handleTabClick}>
                <img
                  className="icon-home"
                  src="/assets/bcimages/sidebar/affiliate.svg"
                />
                <p>Affiliate</p>
              </a>
            </li>
          </Link>

          <Link to="/">
            <li>
              <a onClick={handleTabClick}>
                <img
                  className="icon-home"
                  src="/assets/bcimages/bchome/casino-home-gamecard.svg"
                />
                <p>Home</p>
              </a>
            </li>
          </Link>
          <Link to="/vip-club">
            <li>
              <a onClick={handleTabClick}>
                <img
                  className="icon-home"
                  src="/assets/bcimages/sidebar/vip.svg"
                />
                <p>VIP</p>
              </a>
            </li>
          </Link>
          {/* <li onClick={toggleModal}>
                  <a onClick={handleTabClick}>
                    <img
                      className="icon-home"
                      src="\assets\bcimages\bcheader\chat_icon.svg"
                    />
                    <p>Chat</p>
                  </a>
                </li> */}
        </ul>
      </div>
    </div>
  );

  return renderContent();
};

export default Header;
